import { render, staticRenderFns } from "./searchbar_sammel.vue?vue&type=template&id=c55ceeee&scoped=true"
import script from "./searchbar_sammel.vue?vue&type=script&lang=js"
export * from "./searchbar_sammel.vue?vue&type=script&lang=js"
import style0 from "./searchbar_sammel.vue?vue&type=style&index=0&id=c55ceeee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55ceeee",
  null
  
)

export default component.exports